import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserTypeRolesPage = lazy(() => import('../views/roles/UserTypeRolesPage'));

export function UserTypeRolesPageLazy() {
	return (
		<PageSuspense>
			<UserTypeRolesPage />
		</PageSuspense>
	);
}
